import React from 'react';
import { Navigate, type RouteObject } from 'react-router-dom';
import AdminPage from '../pages/AdminPage';
import SyncHistoryPage from './pages/SyncHistoryPage';

const routes: RouteObject[] = [
  {
    index: true,
    element: <AdminPage tab="sync-history" />,
  },
  {
    path: ':id',
    children: [
      {
        index: true,
        element: <Navigate to="details" replace />,
      },
      {
        path: ':tab',
        element: <SyncHistoryPage />,
      },
    ],
  },
];

export default routes;
